// Single source of truth for the site's real-world data (contracts, links, partners, copy).
import camelot from '../assets/partners/camelot.png';
import stryke from '../assets/partners/stryke.webp';
import jonesDAO from '../assets/partners/jonesdao.png';
import hermes from '../assets/partners/hermes.jpg';
import openocean from '../assets/partners/openocean.png';
import gamma from '../assets/partners/gamma.png';
import orangeFinance from '../assets/partners/orangefinance.jpg';
import factorDAO from '../assets/partners/factor.png';
import maiaDAO from '../assets/partners/maia.jpg';
import bonsaiDAO from '../assets/partners/bondao.webp';
import hamachi from '../assets/partners/hamachi.png';
import synonym from '../assets/partners/synonym.jpg';
import silo from '../assets/partners/silo.png';
import sanko from '../assets/partners/sanko.webp';
import winr from '../assets/partners/winr.png';
import playarts from '../assets/partners/playarts.jpg';
import blueberry from '../assets/partners/blueberry.webp';
import azuki from '../assets/partners/azuki.png';
import fanko from '../assets/partners/fanko.jpg';
import smoovie from '../assets/partners/smoovie.jpg';

export const SITE = {
  name: 'BOOP',
  title: "BOOP | Arbitrum's Best Doggo",
  description:
    "BOOP is Arbitrum's best doggo. Everyone deserves a boop. Memes plus DeFi, mini games and MemeFi rewards, on Arbitrum and Solana.",
  url: 'https://boopthecoin.xyz',
};

export const CONTRACTS = {
  arbitrum: {
    id: 'arbitrum',
    short: 'ARB',
    name: 'Arbitrum',
    standard: 'ERC-20',
    address: '0x13A7DeDb7169a17bE92B0E3C7C2315B46f4772B3',
    explorer: 'https://arbiscan.io/token/0x13A7DeDb7169a17bE92B0E3C7C2315B46f4772B3',
    explorerName: 'Arbiscan',
    relay: 'https://relay.link/bridge/arbitrum?toCurrency=0x13A7DeDb7169a17bE92B0E3C7C2315B46f4772B3',
    payToken: 'ETH',
    payIcon: 'Ξ',
  },
  solana: {
    id: 'solana',
    short: 'SOL',
    name: 'Solana',
    standard: 'SPL (Wormhole)',
    address: '2HrZ5R18H48b8ptL3n8N5zX65zDB4o2cMCHcP3QfSfye',
    explorer: 'https://solscan.io/token/2HrZ5R18H48b8ptL3n8N5zX65zDB4o2cMCHcP3QfSfye',
    explorerName: 'Solscan',
    relay: 'https://relay.link/bridge/solana?toCurrency=2HrZ5R18H48b8ptL3n8N5zX65zDB4o2cMCHcP3QfSfye',
    payToken: 'SOL',
    payIcon: '◎',
  },
};

export const CHAIN_IDS = ['arbitrum', 'solana'];

export const LINKS = {
  x: 'https://x.com/boopthecoin',
  telegram: 'https://t.me/boopthecoin',
  tiktok: 'https://www.tiktok.com/@boopthecoinofficial',
  instagram: 'https://www.instagram.com/boopthecoinofficial/',
  coingecko: 'https://www.coingecko.com/en/coins/boop-2',
  // The game lives in public/games/wab and is served by this same site.
  game: '/games/wab/',
};

export const SOCIALS = [
  { label: 'X / Twitter', href: LINKS.x },
  { label: 'Telegram', href: LINKS.telegram },
  { label: 'TikTok', href: LINKS.tiktok },
  { label: 'Instagram', href: LINKS.instagram },
];

export const MARQUEE = ['EVERYONE DESERVES A BOOP', "ARBITRUM'S BEST DOGGO"];

export const FEATURES = [
  { emoji: '😂', title: 'Fun first', body: 'Memes are the message. If it does not make you smile, it is not BOOP.' },
  { emoji: '🧠', title: 'Memes meet DeFi', body: 'Real chains, real liquidity, wrapped in nose-tap chaos. MemeFi with a wagging tail.' },
  { emoji: '🕹️', title: 'Mini games', body: 'Whack-a-BOOP and friends. Play, compete with the pack, chase that high score.' },
  { emoji: '🐾', title: 'Community vibes', body: 'Telegram fam, X memes, and boopers worldwide. Built to spread like a very good dog.' },
];

export const BOOP_STEPS = [
  { title: 'Approach', body: 'Approach the subject to be booped with care and intention.' },
  { title: 'Establish rapport', body: "For living beings, make sure they're comfortable. Inanimate objects are always ready." },
  { title: 'Position', body: 'Move your finger towards the target area (nose recommended).' },
  { title: 'Execute the BOOP', body: 'Touch gently while saying “BOOP!” and share in the joy.' },
];

export const FAQ = [
  {
    q: 'What is $BOOP?',
    a: 'A memecoin that mixes memes with DeFi. The idea is simple: make finance accessible through community participation and meme sharing. And boops. Lots of boops.',
  },
  {
    q: 'What can I do with BOOP?',
    a: 'Trade the token, play the mini games, join community events, chase MemeFi rewards, and create and share memes with the pack.',
  },
  {
    q: 'Why Arbitrum (and Solana)?',
    a: 'BOOP was born on Arbitrum (ERC-20) for faster, cheaper transactions. A Wormhole-bridged version lives on Solana too, so both crowds can play.',
  },
  {
    q: 'Where do I buy?',
    a: 'Pick Arbitrum or Solana in the Buy $BOOP card and hit “Buy on Relay”. Relay opens with $BOOP already selected; you connect your wallet and see live quotes there, not on this site. Prefer a DEX or another chain? The Buy page has step-by-step guides.',
  },
  {
    q: 'Is it safe?',
    a: 'It is a simple token, but it is still a memecoin. Use the official contract addresses, never share your seed phrase, do your own research and start small.',
  },
  {
    q: 'How can I contribute?',
    a: 'Create memes, play the mini games, hang out in the Telegram, help newcomers, and recruit one friend. Everyone deserves a boop.',
  },
];

export const CORE_CREEDS = [
  { emoji: '😂', title: 'Fun First', body: 'MemeFi takes the complexity out of DeFi and gives people something they can relate to and recognise.' },
  {
    emoji: '🧠',
    title: 'Serious Finance, Memeatic Delivery',
    body: "Underneath the fun exterior, there's real, robust DeFi technology. Leveraging, trading, and earning are all part of the DeFi offering, but way more enjoyable.",
  },
  {
    emoji: '🐾',
    title: 'Community-Centric',
    body: "It's all about the community vibes. Every MemeFi partnership has been carefully curated and negotiated to offer our community members the best experience.",
  },
  {
    emoji: '🚀',
    title: 'Viral Potential',
    body: "Memes spread like wildfire, and so does MemeFi. It's finance that's built to be shared, making it easier than ever to get in on the action.",
  },
];

export const PARTNER_SECTIONS = [
  {
    title: 'Core Partners',
    partners: [
      { name: 'CamelotDex', logo: camelot, link: 'https://camelot.exchange', description: 'Facilitates decentralized trading with optimized liquidity pools on Arbitrum.' },
      { name: 'Stryke', logo: stryke, link: 'https://app.strike.org/dashboard', description: 'A decentralized options trading platform on Arbitrum, offering leveraged liquidity and innovative trading features.' },
      { name: 'JonesDAO', logo: jonesDAO, link: 'https://app.jonesdao.io/vaults', description: 'Offers structured products for risk-managed DeFi investments.' },
    ],
  },
  {
    title: 'Swap tools',
    partners: [
      { name: 'HermesOmnichain', logo: hermes, link: 'https://app.maiadao.io/', description: 'Bridgeless omnichain native token swaps and yield opportunities across various blockchains.' },
      { name: 'OpenOcean', logo: openocean, link: 'https://openocean.finance', description: 'Aggregates liquidity from many chains to provide the best trading prices and seamless cross-chain swaps.' },
      { name: 'GammaSwap', logo: gamma, link: 'https://gamma.xyz', description: 'A DeFi protocol for trading volatility through on-chain perpetual options.' },
    ],
  },
  {
    title: 'Yield Farming & Investment platforms',
    partners: [
      { name: 'OrangeFinance', logo: orangeFinance, link: 'https://www.orangefinance.io/', description: 'Provides yield optimization strategies for DeFi assets.' },
      { name: 'FactorDAO', logo: factorDAO, link: 'https://factor.fi', description: 'Specializes in creating DeFi financial instruments like options and futures.' },
      { name: 'MaiaDAO', logo: maiaDAO, link: 'https://maiadao.io', description: 'A decentralized finance protocol for lending, borrowing, and yield farming.' },
      { name: 'BonsaiDAO', logo: bonsaiDAO, link: 'https://BonsaiDAO.xyz', description: 'Focuses on leveraging collective intelligence for investment decisions in DeFi.' },
      { name: 'Hamachi Finance', logo: hamachi, link: 'https://hamachi.finance', description: 'A multi-currency, multi-chain reward token: holding $HAMI farms rewards across supported Arbitrum projects.' },
      { name: 'Synonym Finance', logo: synonym, link: 'https://app.synonym.finance/', description: 'Tools to bridge, stake, and earn rewards across multiple blockchains, enhancing interoperability.' },
      { name: 'Silo Finance', logo: silo, link: 'https://v2.silo.finance', description: 'A non-custodial lending protocol on Arbitrum with risk-isolated markets where any token can be collateral.' },
    ],
  },
  {
    title: 'Arbitrum L3 Orbit Chain Integrations',
    partners: [
      { name: 'Sanko', logo: sanko, link: 'https://sanko.io', description: 'An Arbitrum Orbit L3 tailored for gaming, using DMT for gas and in-game economies.' },
      { name: 'WINR', logo: winr, link: 'https://winr.games', description: 'Revolutionizes onchain gambling with instant, gasless bets.' },
    ],
  },
  {
    title: 'Fun & Games',
    partners: [
      { name: 'PlayArtsDotAI', logo: playarts, link: 'https://playarts.ai', description: 'An AI-driven platform to create, mint, and trade digital art on-chain.' },
      { name: 'GMX Blueberry Club', logo: blueberry, link: 'https://hub.findgbc.io/', description: '10,000 unique NFTs on Arbitrum with community rewards, trading competitions and more.' },
      { name: 'Azuki', logo: azuki, link: 'https://azuki.com', description: 'Leading NFT project integrating digital art with DeFi functionality.' },
      { name: 'Fanko', logo: fanko, link: 'https://fanko.tech', description: 'A memecoin launchpad on the Sanko chain for quick token creation, buying, and selling.' },
      { name: 'Smoovie', logo: smoovie, link: 'https://www.smooviephone.com/', description: 'A Sanko L3 token mixing DeFi and GameFi: prediction markets, mini-games, and staking.' },
    ],
  },
];

export const ALL_PARTNERS = PARTNER_SECTIONS.flatMap((s) => s.partners);
